import { ValueContainer } from "components/shared/select";
import React from "react";
import BaseTransportColumnFilter from "./transportColumn";

const MultiTransportColumnFilter = (props) => {
    const selectProps = {
        inputProps: { name: "transportColumnIds" },
        value: props.values.transportColumnIds,
        components: { ValueContainer },
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        isMulti: true,
    };
    return <BaseTransportColumnFilter {...props} selectProps={selectProps} />;
};

export default MultiTransportColumnFilter;
